import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';

@Component({
    selector: 'my-micr-details',
    templateUrl: './MICRDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => MICRDetailsComponent) }]
})
export class MICRDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    micrInfo: ent.MICRInfo = new ent.MICRInfo();

    @Input() public showBankKey: boolean;
    @Input() public showBankAccount: boolean;
    @Input() public showUpdateNeeded: boolean;

    @Input() public requireBankKey: boolean;
    @Input() public requireBankAccount: boolean;
    @Input() public requireUpdateNeeded: boolean;



    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.micrInfo = request.MICRInfo;
    }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'bankKey': '',
            'bankAccount': '',
            'updateNeeded': ''
        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {
        if (this.requireBankKey) {
            this.form.controls['bankKey'].setValidators(Validators.required);
        }
        if (this.requireBankAccount) {
            this.form.controls['bankAccount'].setValidators(Validators.required);
        }
        if (this.requireUpdateNeeded) {
            this.form.controls['updateNeeded'].setValidators(Validators.required);
        }

    }

    updateNeededChange(event: any) {
        this.micrInfo.UpdateNeededID = event;
    }

}